export default __webpack_public_path__ + "static/media/ennovate_1.f27701a8.jpg";